export enum DistributionReportStatisticTypesEnum {
    SENT_COUNT = 'SENT_COUNT',
    DELIVERY_RATE = 'DELIVERY_RATE',
    UNIQUE_OPEN_RATE = 'UNIQUE_OPEN_RATE',
    UNIQUE_CLICK_RATE = 'UNIQUE_CLICK_RATE',
    REPLY_RATE = 'REPLY_RATE'
}
